import readNDJSONStream from "ndjson-readablestream";
import { DocumentationApiError, DocumentationProgressEvent } from "./models";

export async function readProcessingEvents(body: ReadableStream<Uint8Array>, onActivity?: () => void): Promise<DocumentationProgressEvent[]> {
    const events: DocumentationProgressEvent[] = [];
    for await (const event of readNDJSONStream(body)) {
        onActivity?.();
        if (event.event === "heartbeat") continue;
        if (event.event === "error") {
            throw new DocumentationApiError(
                typeof event.code === "string" ? event.code : "DOCUMENTATION_PROCESS_FAILED",
                typeof event.message === "string" ? event.message : "Documentation processing failed.",
                typeof event.status === "number" ? event.status : 500
            );
        }
        events.push(event as DocumentationProgressEvent);
    }
    if (!events.length) throw new DocumentationApiError("EMPTY_PROCESS_RESPONSE", "The processing connection ended before returning a result.", 502);
    return events;
}
